import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ProjectsSection() {
  const projects = [
    {
      title: 'Residência Jardins',
      category: 'Residencial de Luxo',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/ca3fb965b804ab29f3955399b8679132.jpeg'
    },
    {
      title: 'Edifício Comercial Vila Olímpia',
      category: 'Comercial Premium',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/63dae07436f2260d7a53af34392c8b59.jpeg'
    },
    {
      title: 'Cobertura Itaim Bibi',
      category: 'Residencial Exclusivo',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/924cbf9e1c3b44c07e8f709866809915.jpeg'
    },
    {
      title: 'Escritório Corporativo Faria Lima',
      category: 'Comercial Executivo',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/c9f4a3561038984837419bc617832f04.jpeg'
    },
    {
      title: 'Casa de Campo Alphaville',
      category: 'Residencial Premium',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/9a7462cc2b2994636ae758966e45a3ca.jpeg'
    },
    {
      title: 'Loft Industrial Vila Madalena',
      category: 'Residencial Moderno',
      image: 'https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/f484b8e450d6207d2627d9f596b19a03.jpeg'
    }
  ];

  return (
    <section id="projects" className="py-16 bg-[#F2F2F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Projetos que inspiram confiança
          </h2>
          <p className="text-lg text-[#3F3F3F] max-w-3xl mx-auto leading-relaxed">
            Participamos de projetos residenciais e comerciais de alto padrão em São Paulo. Cada projeto conta uma história — guiada por excelência técnica e olhar humano.
          </p>
        </div>

        {/* Projects Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="bg-white p-8 rounded-2xl shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-2xl font-bold text-[#5C1A24] mb-1" style={{ fontFamily: '"Playfair Display", serif' }}>
                100+
              </div>
              <div className="text-[#3F3F3F] font-medium text-sm">Projetos Entregues</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-[#5C1A24] mb-1" style={{ fontFamily: '"Playfair Display", serif' }}>
                50M+
              </div>
              <div className="text-[#3F3F3F] font-medium text-sm">m² Construídos</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-[#5C1A24] mb-1" style={{ fontFamily: '"Playfair Display", serif' }}>
                6+
              </div>
              <div className="text-[#3F3F3F] font-medium text-sm">Anos de Experiência</div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link 
            to="/projetos"
            className="bg-[#5C1A24] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#4A1520] transition-colors cursor-pointer whitespace-nowrap inline-block"
          >
            <i className="ri-gallery-line mr-2"></i>
            Ver todos os projetos
          </Link>
        </div>
      </div>
    </section>
  );
}
